import { ExamLoadCtrl } from './exam-load.controller';

export const ExamLoadStepComponent = {
  controller: ExamLoadCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./exam-load.html'),
};
